module.exports = __webpack_public_path__ + "lock.78415eb4.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/lock.png
// module id = 346
// module chunks = 0